{
    "editorial_question.share_thoughts": "Jetzt mitdiskutieren",
    "simple_ranking.most_reactions": "Meist reagiert"
}
